/* src/app/shared/dialog/screen-dialog/screen-historic/screen-historic.component.scss */
.custom-header {
  background-color: rgba(36, 70, 102, 0.05);
}
.custom-header .mat-header-cell {
  border-bottom: 1px solid #DFEBF7;
  color: #001A33;
  text-align: center;
  font: 700 12px FranceTV Brown;
}
.table {
  border: 1px solid #DFEBF7;
  border-radius: 5px;
  margin-top: 15px;
  overflow: auto;
  height: calc(100vh - 260px) !important;
}
.mat-cell.mat-cell-center-align {
  text-align: center;
  color: #001A33;
  font: 400 12px FranceTV Brown;
}
/*# sourceMappingURL=screen-historic.component.css.map */
